import { ParameterTimeSeriesChartResult } from "@/lib/api";
import { DimensionValue } from "@/lib/dimensions";

import Linegraph from "./linegraph";
import type { TimeSeriesConfig } from "./graph.types";
import type { ChartTimeBounds } from "./get-shared-chart-time-bounds";
import Histogram from "./histogram";
import Scatterplot from "./scatterplot";
import VectorPlot from "./vector-plot";
import AvaIndexGraph from "./ava-index-graph";
import PasquillTimeline from "./pasquill-timeline";

interface GraphProps {
  config: TimeSeriesConfig;
  data: ParameterTimeSeriesChartResult[];
  currentTime: DimensionValue;
  timeBounds?: ChartTimeBounds;
  /** Numeric px height; skips map-panel legend auto-grow. Vector defaults to 150. */
  height?: number;
}

// TODO: rename to TimeSeriesGraph ???
const Graph = ({ config, data, currentTime, timeBounds, height }: GraphProps) => {
  switch (config.type) {
    case "line_graph":
      return (
        <Linegraph
          config={config}
          data={data}
          currentTime={currentTime}
          timeBounds={timeBounds}
          height={height}
        />
      );

    case "histogram":
      return (
        <Histogram
          config={config}
          data={data}
          currentTime={currentTime}
          timeBounds={timeBounds}
          height={height}
        />
      );

    case "scatterplot":
      return (
        <Scatterplot
          config={config}
          data={data}
          currentTime={currentTime}
          timeBounds={timeBounds}
          height={height}
        />
      );

    case "vector_plot":
      return (
        <VectorPlot
          config={config}
          data={data}
          currentTime={currentTime}
          timeBounds={timeBounds}
          height={height}
        />
      );

    case "ava_index":
      return (
        <AvaIndexGraph
          config={config}
          data={data}
          currentTime={currentTime}
          timeBounds={timeBounds}
          height={height}
        />
      );

    case "pasquill":
      return (
        <PasquillTimeline
          config={config}
          data={data}
          currentTime={currentTime}
          timeBounds={timeBounds}
          height={height}
        />
      );

    default:
      // no known graph type
      return null;
  }
};

export default Graph;
